import React__default, { createElement, Component } from 'react';
import nextWithRedux from 'next-redux-wrapper';
import { initStore } from '@grandvision/state';
import NextApp from 'next/app';
import getConfig from 'next/config';
import { initApolloClient, ApolloProvider } from '@grandvision/graphql';
import { CmsHeader, CmsFooter } from '@grandvision/bloomreach';
import { PageLayout, ErrorPage } from '@grandvision/layout';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var withRedux = function (App) {
    var Wrapper = /** @class */ (function (_super) {
        __extends(Wrapper, _super);
        function Wrapper() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Wrapper.getInitialProps = function (props) {
            return __awaiter(this, void 0, void 0, function () {
                var pageProps, _a, isServer, store;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            pageProps = {};
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, , 4, 7]);
                            if (!(typeof App.getInitialProps === 'function')) return [3 /*break*/, 3];
                            return [4 /*yield*/, App.getInitialProps(props)];
                        case 2:
                            pageProps = _b.sent();
                            _b.label = 3;
                        case 3: return [3 /*break*/, 7];
                        case 4:
                            _a = props.ctx, isServer = _a.isServer, store = _a.store;
                            if (!isServer) return [3 /*break*/, 6];
                            return [4 /*yield*/, store.close()];
                        case 5:
                            _b.sent();
                            _b.label = 6;
                        case 6: return [7 /*endfinally*/];
                        case 7: return [2 /*return*/, pageProps];
                    }
                });
            });
        };
        Wrapper.prototype.render = function () {
            return createElement(App, __assign({}, this.props));
        };
        return Wrapper;
    }(Component));
    return nextWithRedux(initStore)(Wrapper);
};

var publicRuntimeConfig = getConfig().publicRuntimeConfig;
var apigeeKey = publicRuntimeConfig.apigeeKey, grandvision = publicRuntimeConfig.grandvision;
var graphQLUrl = grandvision.endpoints.graphql;
var getDisplayName = function (Component) {
    return Component.displayName || Component.name || 'Unknown';
};
var withApollo = function (options) { return function (PageComponent) {
    var WithApollo = function (_a) {
        var apolloClient = _a.apolloClient, apolloState = _a.apolloState, pageProps = __rest(_a, ["apolloClient", "apolloState"]);
        var client = apolloClient || initApolloClient(graphQLUrl, { apigeeKey: apigeeKey, initialState: apolloState });
        return (React__default.createElement(ApolloProvider, { client: client },
            React__default.createElement(PageComponent, __assign({}, pageProps))));
    };
    if (PageComponent.getInitialProps) {
        WithApollo.getInitialProps = function (ctx) { return __awaiter(void 0, void 0, void 0, function () {
            var inAppContext, apolloClient, pageProps, apolloState;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        inAppContext = Boolean(ctx === null || ctx === void 0 ? void 0 : ctx.ctx);
                        if (ctx.apolloClient) {
                            console.error('Multiple instances of withApollo found.');
                            throw new Error('Multiple instances of withApollo found.');
                        }
                        apolloClient = initApolloClient(graphQLUrl, { apigeeKey: apigeeKey });
                        // Add apolloClient to NextPageContext & NextAppContext
                        // This allows us to consume the apolloClient inside our
                        // custom `getInitialProps({ apolloClient })`.
                        ctx.apolloClient = apolloClient;
                        if (inAppContext) {
                            ctx.ctx.apolloClient = apolloClient;
                        }
                        pageProps = {};
                        if (!PageComponent.getInitialProps) return [3 /*break*/, 2];
                        return [4 /*yield*/, PageComponent.getInitialProps(ctx)];
                    case 1:
                        pageProps = _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!inAppContext) return [3 /*break*/, 4];
                        return [4 /*yield*/, NextApp.getInitialProps(ctx)];
                    case 3:
                        pageProps = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (typeof window === 'undefined') {
                            // When redirecting, the response is finished.
                            // No point in continuing to render
                            if (ctx.res && (ctx.res.headersSent || ctx.res.finished)) {
                                return [2 /*return*/, pageProps];
                            }
                        }
                        apolloState = apolloClient.cache.extract();
                        return [2 /*return*/, __assign(__assign({}, pageProps), { apolloState: apolloState })];
                }
            });
        }); };
    }
    WithApollo.displayName = "WithApollo(" + getDisplayName(PageComponent) + ")";
    return WithApollo;
}; };

var withErrorPage = function (PageComponent) {
    var WithErrorPage = function (props) {
        var _a = props.asPath, asPath = _a === void 0 ? '/' : _a, buttonText = props.buttonText, image = props.image, pageModel = props.pageModel, statusCode = props.statusCode, subheader = props.subheader, title = props.title;
        if (statusCode && statusCode >= 400) {
            return (createElement(PageLayout, { header: createElement(CmsHeader, { pageModel: pageModel, asPath: asPath, preview: false, isMyAccountEnabled: function () { return false; }, isSolaris: false, siteName: title }), footer: createElement(CmsFooter, { pageModel: pageModel, preview: false, siteName: title }) },
                createElement(ErrorPage, { header: title, buttonText: buttonText, image: image, subheader: subheader })));
        }
        return createElement(PageComponent, __assign({}, props));
    };
    WithErrorPage.getInitialProps = function (ctx) { return __awaiter(void 0, void 0, void 0, function () {
        var pageProps, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!PageComponent.getInitialProps) return [3 /*break*/, 2];
                    return [4 /*yield*/, PageComponent.getInitialProps(ctx)];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = null;
                    _b.label = 3;
                case 3:
                    pageProps = (_a) || {};
                    if (pageProps.statusCode && ctx.res) {
                        ctx.res.statusCode = pageProps.statusCode;
                    }
                    return [2 /*return*/, pageProps];
            }
        });
    }); };
    WithErrorPage.displayName = "WithErrorPage(" + (PageComponent.displayName || PageComponent.name || 'Unknown') + ")";
    return WithErrorPage;
};

export { withApollo, withErrorPage, withRedux };
//# sourceMappingURL=index.es.js.map
